import { useQuery } from "@tanstack/react-query";
import { ProductService } from "../services/productService";


export const useAdminProduct = (id: String) => useQuery({
    queryKey: [],
    queryFn: ProductService.getAllProducts,
});

export const useHomeProducts = () => useQuery({
    queryKey: [],
    queryFn: ProductService.getAllProducts,
});

export const useProducts = () => {
  const { data: products, isLoading, error, refetch } = useQuery({
    queryKey: ['products'],
    queryFn: () => ProductService.getAllProducts(),
  });

  return {
    products,
    isLoading,
    error,
    refetch,
  };
};